<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 34.85 22.46">
    <g id="Camada_1-2" data-name="Camada_1">
      <path d="M4.86,17.34c-1.26-1.28-2.52-2.56-3.78-3.84-1.46-1.49-1.44-3.4.06-4.88C3.69,6.1,6.26,3.59,8.81,1.06,9.52.36,10.35,0,11.33,0c6.75.05,13.49.09,20.24.17,1.99.02,3.29,1.36,3.28,3.35-.02,5.22-.06,10.44-.12,15.67-.02,1.99-1.36,3.28-3.36,3.27-6.73-.04-13.45-.1-20.18-.15-1.01,0-1.85-.38-2.56-1.12-1.24-1.3-2.52-2.56-3.78-3.85ZM4.9,12.78c.93.95,2.42.98,3.37.07.96-.92.98-2.48.04-3.43-.93-.93-2.43-.94-3.37-.01-.95.93-.97,2.41-.04,3.37Z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PixelIcon'
}
</script>
